import React, { Suspense } from 'react'

import { DialogProps, DialogType } from '../../redux/dialog/types'

import {
  AccountReportsAdvancedFilter,
  ChangePasswordDialog,
  ChangeLanguageDialog,
  EditPhoneNumberDialog,
  EditOfficeNameDialog,
  CompanyConsentDialog,
  InfoDialog,
  PoliciesDialog,
  PolicyContentDialog,
  ReportDetail,
  ReportPurchaseDetail,
  UpdateBillingAddress,
  UpdateTaxId,
  ArchiveExportDialog,
  NotificationDetailDialog,
  UpdateBillingEmail,
  TransactionsDialog,
  TransactionsAdvancedFilterDialog,
  TransactionsExportDialog,
  ProfileManagementAdvancedFilterDialog,
  InvitationLinkGenerationDialog,
  ProfileManagementEditAccountDialog,
  ProfileManagementDeleteAccountDialog,
  ImportValidationExportDialog,
  ImportHistoryExportDialog,
  ImportHistoryAdvancedFilter,
  ImportSearchExportDialog,
  CheckProductsConfirmDialog,
  ImportInvestigationDialog,
  InvoicesAdvancedFilterDialog,
  InvoiceDetailsDialog,
  UpdatePreferredProductDialog,
  ConfirmPreferredProductChangeDialog
} from './Dialogs'

const Dialogs: Record<DialogType, React.ComponentType<DialogProps>> = {
  ChangePassword: ChangePasswordDialog,
  ChangeLanguage: ChangeLanguageDialog,
  EditPhoneNumber: EditPhoneNumberDialog,
  EditOfficeName: EditOfficeNameDialog,
  UpdateBillingAddress: UpdateBillingAddress,
  UpdateBillingEmail: UpdateBillingEmail,
  UpdateTaxId: UpdateTaxId,
  ReportDetail: ReportDetail,
  ReportPurchaseDetail: ReportPurchaseDetail,
  Info: InfoDialog,
  PolicyContent: PolicyContentDialog,
  CompanyConsent: CompanyConsentDialog,
  AccountReportsAdvancedFilter: AccountReportsAdvancedFilter,
  PoliciesDialog,
  ArchiveExportDialog,
  NotificationDialog: NotificationDetailDialog,
  TransactionsDialog,
  TransactionsAdvancedFilter: TransactionsAdvancedFilterDialog,
  TransactionsExport: TransactionsExportDialog,
  ProfileManagementAdvancedFilter: ProfileManagementAdvancedFilterDialog,
  ProfileManagementInvitationLinkGeneration: InvitationLinkGenerationDialog,
  ProfileManagementEditAccount: ProfileManagementEditAccountDialog,
  ProfileManagementDeleteAccount: ProfileManagementDeleteAccountDialog,
  ImportValidationExport: ImportValidationExportDialog,
  ImportHistoryExport: ImportHistoryExportDialog,
  ImportHistoryAdvancedFilter: ImportHistoryAdvancedFilter,
  ImportSearchExport: ImportSearchExportDialog,
  CheckProductsConfirm: CheckProductsConfirmDialog,
  ImportInvestigation: ImportInvestigationDialog,
  InvoicesAdvancedFilter: InvoicesAdvancedFilterDialog,
  InvoiceDetailsDialog: InvoiceDetailsDialog,
  UpdatePreferredProductDialog: UpdatePreferredProductDialog,
  ConfirmPreferredProductChangeDialog: ConfirmPreferredProductChangeDialog
}

type Props = {
  dialogType?: DialogType
} & DialogProps

const DialogRendererComponent = (props: Props) => {
  const { dialogType } = props
  if (!dialogType) return null
  if (Dialogs[dialogType]) {
    return <Suspense fallback={false}>{React.createElement(Dialogs[dialogType], props)}</Suspense>
  }
  return null
}

export default DialogRendererComponent
